// TODO think about implementation error getter
// for react query and error format like for promocodes and influencers
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

export const errorMessageGetter = (e) => {
  const messages = get(e, 'debug.body.errors', e.messages);
  const message = get(e, 'debug.body.Message', e.message);
  return !isEmpty(messages) ? map(messages, (e) => e.message) : [message];
};
